export const currentVersion = '"20230105T154755"';
